import React, { ReactNode } from "react";
import { cn } from "../../../utils/cn";

interface IconBadgeProps {
  icon: ReactNode;
  onClick?: () => void;
  styles?: string;
}

const IconBadge = ({ icon, onClick, styles }: IconBadgeProps) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        "w-10 h-10 bg-purple-primary/10 cursor-pointer flex items-center justify-center rounded-full",
        styles,
      )}
    >
      {icon}
    </div>
  );
};

export default React.memo(IconBadge);
